import { useEffect, useState } from 'react';
import { DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';

import { CustomCheckbox } from 'src/components/CustomCheckbox';
import { CustomDialog } from 'src/components/CustomDialog';
import { CustomFormControlLabel } from 'src/components/CustomFormControlLabel';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const FormatSelectionPopup = ({ open, onApply, onCancel, formats, selectedFormatIds }) => {
  const styles = useStyles();
  const [selectedIds, setSelectedIds] = useState(selectedFormatIds || []);

  // Update internal state when popup opens with current selection
  useEffect(() => {
    if (open) {
      setSelectedIds(selectedFormatIds || []);
    }
  }, [open, selectedFormatIds]);

  const handleToggle = (id) => {
    setSelectedIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const handleApply = () => {
    onApply(selectedIds);
  };

  return (
    <CustomDialog
      className={styles.root}
      open={open}
      onClose={onCancel}
      title="Formats"
      onSubmit={handleApply}
      onCancel={onCancel}
      submitLabel="Apply"
      cancelLabel="Cancel"
      fullWidth
    >
      <DialogContent className={styles.dialogContent}>
        <div className={styles.list}>
          {formats.map((format) => (
            <div
              key={format.id}
              className={styles.itemContainer}
            >
              <CustomFormControlLabel
                className={styles.item}
                control={
                  <CustomCheckbox
                    checked={selectedIds.includes(format.id)}
                    onChange={() => handleToggle(format.id)}
                    color="primary"
                  />
                }
                label={
                  <CustomTypography variant={TYPOGRAPHY_VARIANT.regular16}>
                    {format.name}
                  </CustomTypography>
                }
              />
            </div>
          ))}
        </div>
      </DialogContent>
    </CustomDialog>
  );
};

FormatSelectionPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onApply: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  formats: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedFormatIds: PropTypes.arrayOf(PropTypes.string),
};

FormatSelectionPopup.defaultProps = {
  selectedFormatIds: [],
};
